import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':accountId'}/edit`;

export const ROUTE: RouteDefinition = `${baseRoute}/:accountId/edit`;

export const URL = (accountId: number): RouteDefinition => `${baseRoute}/${accountId}/edit`;
